import { render, staticRenderFns } from "./RacialTraitFields.vue?vue&type=template&id=6c4ce51c"
import script from "./RacialTraitFields.vue?vue&type=script&lang=js"
export * from "./RacialTraitFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports